import AppearOnScroll from "./AppearOnScroll";

function Pill(props) {
    return (
      <AppearOnScroll delay={0.2}>
      <div className="flex align-middle items-center bg-lightgrey font-body font-medium lg:text-base text-sm px-3 py-1 g-lightgrey backdrop-blur-md shadow-sm rounded-xl">{props.children}       
      </div>
      </AppearOnScroll>
    );
  }
  
  export default Pill;